import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AvisClientsCarousel from '../components/AvisClientsCarousel';
import ProtectedImage from '../components/ProtectedImage';
import { getVehiclesPublic } from '../services/api';
import { useScrollRestore } from '../hooks/useScrollRestore';

function VehiculesVendus() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 9;

  useEffect(() => {
    getVehiclesPublic()
      .then(res => {
        const vendus = res.data.filter(v => v.statut === 'VENDU');
        setVehicles(vendus);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  useScrollRestore(loading);

  return (
    <div className="bg-white min-h-screen">
      <Header />
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-extrabold text-black mb-4">
            Véhicules <span className="text-yellow-500">vendus</span>
          </h1>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-gray-500 text-lg">Les véhicules qui ont trouvé leur propriétaire</p>
        </div>

        {loading ? (
          <div className="text-center text-yellow-500 text-xl py-20">Chargement...</div>
        ) : vehicles.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-6xl mb-4">🏁</p>
            <p className="text-2xl text-gray-500 mb-2">Aucun véhicule vendu pour le moment</p>
          </div>
        ) : (() => {
          const totalPages = Math.ceil(vehicles.length / PAGE_SIZE) || 1;
          const paginated = vehicles.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
          const getPageNums = (cur, tot) => {
            if (tot <= 7) return Array.from({ length: tot }, (_, i) => i + 1);
            const p = [1];
            if (cur > 4) p.push('...');
            for (let i = Math.max(2, cur - 1); i <= Math.min(tot - 1, cur + 1); i++) p.push(i);
            if (cur < tot - 3) p.push('...');
            p.push(tot);
            return p;
          };
          const goToPage = (p) => { setPage(p); document.getElementById('vehicules-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
          return (
            <>
              <div id="vehicules-section" />
              <p className="text-gray-500 mb-8">{vehicles.length} véhicule(s) vendu(s)</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {paginated.map(vehicle => (
                  <Link key={vehicle.id} id={`vehicle-${vehicle.id}`} to={`/vehicle/${vehicle.id}`} onClick={() => sessionStorage.setItem('scrollToVehicle', vehicle.id)}>
                    <div className="relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer" style={{ height: '380px' }}>
                      {vehicle.mainImageUrl ? (
                        <ProtectedImage src={vehicle.mainImageUrl} alt={vehicle.marque} className="w-full h-full hover:scale-105 transition-transform duration-500" style={{ objectFit: 'cover' }} />
                      ) : (
                        <div className="w-full h-full bg-gray-100 flex items-center justify-center text-6xl">🚗</div>
                      )}
                      <div className="absolute inset-0 bg-black/50"></div>
                      <div className="absolute inset-0 flex items-center justify-center z-10">
                        <span className="bg-yellow-500 text-black text-2xl font-extrabold px-8 py-4 rounded-2xl transform -rotate-12 shadow-xl">VENDU</span>
                      </div>
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-5">
                        <h3 className="text-white font-bold text-xl">{vehicle.marque} {vehicle.modele}</h3>
                        <p className="text-gray-300 text-sm">{vehicle.annee} - {vehicle.carburant} - {vehicle.transmission}</p>
                        <p className="text-yellow-400 text-sm font-semibold mt-2">Voir les détails →</p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
              {totalPages > 1 && (
                <div className="flex items-center justify-center gap-2 mt-12 flex-wrap">
                  <button onClick={() => goToPage(page - 1)} disabled={page === 1} className="w-10 h-10 rounded-xl border border-gray-200 flex items-center justify-center text-gray-500 disabled:opacity-30 hover:border-yellow-500 hover:text-yellow-600 transition font-bold">«</button>
                  {getPageNums(page, totalPages).map((p, i) =>
                    p === '...' ? <span key={`e-${i}`} className="w-10 h-10 flex items-center justify-center text-gray-400 text-sm">…</span>
                    : <button key={p} onClick={() => goToPage(p)} className={`w-10 h-10 rounded-xl border text-sm font-bold transition ${p === page ? 'bg-yellow-500 border-yellow-500 text-black' : 'border-gray-200 text-gray-600 hover:border-yellow-500 hover:text-yellow-600'}`}>{p}</button>
                  )}
                  <button onClick={() => goToPage(page + 1)} disabled={page === totalPages} className="w-10 h-10 rounded-xl border border-gray-200 flex items-center justify-center text-gray-500 disabled:opacity-30 hover:border-yellow-500 hover:text-yellow-600 transition font-bold">»</button>
                </div>
              )}
            </>
          );
        })()}
      </div>
      <AvisClientsCarousel />
      <Footer />
    </div>
  );
}

export default VehiculesVendus;